const LANG_TAG_RE = /<(fr|en|de|es|nl|pt|co|it)>([\s\S]*?)(?:<\/\1>|<\1\/>)/gi;

// Extrait la traduction d'un texte balisé (<fr>…</fr>, <en>…</en>…).
// Sans balises, le texte est retourné tel quel ; sinon la langue demandée,
// à défaut le français, à défaut la première langue trouvée.
export function pickLocalized(text, locale) {
    if (!text) return text;
    const parts = {};
    for (const match of text.matchAll(LANG_TAG_RE)) {
        parts[match[1].toLowerCase()] = match[2].trim();
    }
    if (!Object.keys(parts).length) return text;
    return parts[locale] ?? parts.fr ?? Object.values(parts)[0];
}

export function localizedLangs(text) {
    if (!text) return [];
    return [...text.matchAll(LANG_TAG_RE)].map(match => match[1].toLowerCase());
}
